module.exports = __webpack_public_path__ + "static/media/earth_icon.09ad7fde.svg";